import {prop} from 'ramda';

import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {DASHBOARD_TILE_CATALOGUE} from './dashboardTileCatalogue';
import {DASHBOARD_TILE_IDS} from './dashboardTileIds';

export function buildDefaultDashboardArrangement(): DashboardTilePlacement[] {
  return DASHBOARD_TILE_IDS.map((id) => ({
    id,
    size: prop(id, DASHBOARD_TILE_CATALOGUE).defaultSize,
    isVisible: true,
  }));
}
